import React, { useState, useEffect, useRef } from "react";
import { Trans, withTranslation, useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";

import TaxonomySelector from "../taxonomy/TaxonomySelector";
import { discussionClient } from "../../AxiosClient";

function MoveExpertQuestion(props) {
  const { t } = useTranslation();
  const [taxonomyId, setTaxonomyId] = useState(null);

  const { enqueueSnackbar } = useSnackbar();
  const moveExpertQuestion = () => {
    discussionClient
      .patch(`expertquestion/${props.expertQuestionId}`, { taxonomyId })
      .then((res) => {
        enqueueSnackbar(t("expert_question_move_success", {}), {
          variant: "success",
        });
      })
      .catch(() => {
        enqueueSnackbar(t("expert_question_move_failed"), {
          variant: "error",
        });
      });
    props.close();
  };
  return (
    <div>
      <DialogTitle>
        <Trans i18nKey="move_expert_question" />
      </DialogTitle>
      <DialogContent>
        <TaxonomySelector
          includeRoledUsers
          allowedSelections={["taxonomy"]}
          onNodeSelected={(taxNode) => setTaxonomyId(taxNode.id)}
          filter={taxonomyId ? [{ id: taxonomyId, type: "taxonomy" }] : []}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={props.close} color="primary">
          {t("global_cancel")}
        </Button>
        <Button onClick={() => moveExpertQuestion()}>{t("global_save")}</Button>
      </DialogActions>
    </div>
  );
}

export default MoveExpertQuestion;
